import {CSSProperties} from 'aphrodite';

export default function hoverAndActiveStyles(styles: CSSProperties): CSSProperties {
  return {
    ':hover': styles,
    ':active': styles,
    ':focus': styles,
  };
}
